export default {
    init() {
        
    },
    finalize() {
        
        
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/contacts.js